/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import { Faq } from 'ui/atoms/Faq/Faq';
import { DataFlowSection } from 'ui/organisms/DataFlowSection/DataFlowSection';

import styles from './BusinessCreditRiskPage.module.scss';

import { getBusinessCreditRiskChannels, getFaqItems } from './BusinessCreditRiskPage.data';
import { BusinessCreditRiskAudience } from './sections/BusinessCreditRiskAudience/BusinessCreditRiskAudience';
import { BusinessCreditRiskFile } from './sections/BusinessCreditRiskFile/BusinessCreditRiskFile';
import { BusinessCreditRiskHero } from './sections/BusinessCreditRiskHero/BusinessCreditRiskHero';
import { BusinessCreditRiskCta } from './sections/BusinessCreditRiskCta/BusinessCreditRiskCta';
import { BusinessCreditRiskMonitoring } from './sections/BusinessCreditRiskMonitoring/BusinessCreditRiskMonitoring';
import { BusinessCreditRiskTestimonial } from './sections/BusinessCreditRiskTestimonial/BusinessCreditRiskTestimonial';

export const BusinessCreditRiskPage = () => {
  const { t } = useInt();

  return (
    <div className={styles.wrapper}>
      <BusinessCreditRiskHero />
      <BusinessCreditRiskFile />
      <BusinessCreditRiskMonitoring />
      <DataFlowSection
        title={t('How you get the data')}
        sourceTitle={
          <>
            {t('One verified dataset.')}
            <br />
            <span>{t('600M+ companies.')}</span>
          </>
        }
        sourceText={t(
          'Sourced from 400+ government registries across 200+ countries. Every record attributed to the filing it came from.',
        )}
        channels={getBusinessCreditRiskChannels(t)}
      />
      <BusinessCreditRiskAudience />
      <BusinessCreditRiskTestimonial />
      <BusinessCreditRiskCta />
      <Faq title={t('Questions credit teams ask first')} data={getFaqItems(t)} />
    </div>
  );
};
